import { Link } from "react-router-dom";
import { PageHero } from "@/components/PageHero";
import { PRACTICE_AREAS } from "@/data/practiceAreas";
import { LEGAL_NAV } from "@/data/legal";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const linkCls =
  "font-serif text-base text-charcoal/75 hover:text-forest transition-colors duration-300";

const Group = ({ title, children }) => (
  <div>
    <p className="font-sans text-[11px] tracking-[0.2em] uppercase text-gold mb-4">{title}</p>
    <div className="flex flex-col gap-2.5">{children}</div>
  </div>
);

export default function SitemapPage() {
  useDocumentMeta({
    title: "Sitemap",
    description: "A full map of every page on the AMADI Legal Consultancy website.",
    path: "/sitemap",
  });

  return (
    <div data-testid="sitemap-page">
      <PageHero eyebrow="Legal" title="Sitemap" subtitle="Every page on the AMADI website, in one place." current="Sitemap" />

      <section className="bg-canvas py-14 md:py-20">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
          <Group title="Main">
            <Link to="/" className={linkCls}>Home</Link>
            <Link to="/about" className={linkCls}>About</Link>
            <Link to="/insights" className={linkCls}>Insights</Link>
            <Link to="/contact" className={linkCls}>Contact</Link>
          </Group>

          <Group title="Practice Areas">
            {PRACTICE_AREAS.map((area) => (
              <Link key={area.slug} to={`/practice/${area.slug}`} className={linkCls}>
                {area.title}
              </Link>
            ))}
          </Group>

          <Group title="Legal">
            {LEGAL_NAV.filter((l) => l.to !== "/sitemap").map((l) => (
              <Link key={l.to} to={l.to} className={linkCls}>
                {l.label}
              </Link>
            ))}
          </Group>
        </div>
      </section>
    </div>
  );
}
